import { render, staticRenderFns } from "./CustomerFormDialog.vue?vue&type=template&id=21356f28&scoped=true"
import script from "./CustomerFormDialog.vue?vue&type=script&lang=js"
export * from "./CustomerFormDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerFormDialog.vue?vue&type=style&index=0&id=21356f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21356f28",
  null
  
)

export default component.exports